import svgUrl from "ni:svgr;JiPPMvBT2v2luBMqhAPMoIaU7xtps1TGyVpXjme9Eq0";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const ChartLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="var(--tbl--colors--icons--transformation--primary)" fillRule="evenodd" d="M22 7.714a1 1 0 0 0-1-1h-5V29h6V7.714ZM10 29v-9.905H5a1 1 0 0 0-1 1V29h6Z" clipRule="evenodd" opacity={0.5} /><path fill="var(--tbl--colors--icons--transformation--secondary)" d="M27 10a1 1 0 0 1 1 1v18h-6V10h5Z" /><path fill="var(--tbl--colors--icons--transformation--primary)" d="M15 3a1 1 0 0 1 1 1v25h-6V4a1 1 0 0 1 1-1h4Z" /></svg>;
const Memo = memo(ChartLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ChartLIcon";
}